<template>
    <div id="header" class="col-12 mt-3">
        <div >
            <img :src="logo" alt="logo" class="logo mb-4">
        </div>
        <div class="col-12 text-center">
            <slot name="title"></slot>
        </div>
        <div class="row">
            <div class="col-4">
                <router-link class="menu-link" to="/dashboard" exact>Início</router-link>
            </div>
            <div class="col-4">
                <router-link class="menu-link" to="/dashboard/user" exact>Meus dados</router-link>
            </div>
            <div class="col-4">
                <router-link class="menu-link" to="/dashboard/access" exact>Email e senha</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    
export default {
  name: "DashboardPage",
  data(){
      return{
        logo: ''
      }
  },
  mounted(){
    if(!localStorage.jwt){
        this.$router.push('/');
    }
    else{
        this.logo = JSON.parse(localStorage.application).app_logo
        console.log(this.logo)
    }
  }
};
</script>

<style>
#header{
    margin-bottom: 30px;
    margin-top: 30px;
}

.menu-link{
    font-weight: 900;
}
.menu-link {
    font-weight: 500 !important;
    opacity: 0.4;
    transition: opacity 0.2s ease;
    font-family: "Montserrat", sans-serif;
}
.router-link-active{
    opacity: 1;
}
</style>